module.exports = __webpack_public_path__ + "images/init/upcoming-empty-5b5bb15616113501c4c276464933f3d8.png";